import styled from "styled-components";
import { ChevronLeft, ChevronRight } from "../icons";
import { useEffect, useState } from "react";

const Container = styled.div`
  display: flex;
  overflow: hidden;
  position: relative;
`;
const StartItem = styled.div`
  width: 25vw;
  position: relative;

  @media (max-width: 576px) {
    display: none;
  }

  & img {
    height: 98.5%;
    position: absolute;
    right: 0;
    top: 0;
  }

  & .item-background {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    background: linear-gradient(to top, #6c6b6b, #00000054);
    border-radius: 0 1em 0 0;
  }

  & .item-content {
    position: absolute;
    bottom: 0;
    left: -50vh;
    padding: 0.75em;
    color: white;
    text-align: left;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }

    & h3 {
      margin: 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }

    & p {
      margin: 0.5em 0 0 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
`;
const MainItem = styled.div`
  width: 50vw;
  position: relative;
  border-radius: 0 1em;
  overflow: hidden;
  margin: 0 1em;

  @media (max-width: 576px) {
    width: 100vh;
  }

  & img {
    width: 100%;
    height: auto;
  }

  & .item-background {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    background: linear-gradient(to top, #6c6b6b, #00000054);
    border-radius: 0 1em;
  }

  & .item-content {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 0.75em;
    color: white;
    text-align: left;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }

    & h3 {
      margin: 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }

    & p {
      margin: 0.5em 0 0 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
`;
const EndItem = styled.div`
  width: 25vw;
  position: relative;

  @media (max-width: 576px) {
    display: none;
  }

  & img {
    height: 98.5%;
    position: absolute;
    left: 0;
    top: 0;
  }

  & .item-background {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    background: linear-gradient(to top, #6c6b6b, #00000054);
    border-radius: 0 0 0 1em;
  }

  & .item-content {
    position: absolute;
    bottom: 0;
    right: -50vh;
    padding: 0.75em;
    color: white;
    text-align: left;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }

    & h3 {
      margin: 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }

    & p {
      margin: 0.5em 0 0 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
`;

const Navigation = styled.div`
  position: absolute;
  top: 45%;
  width: 100%;
  display: flex;

  @media (max-width: 576px) {
    top: 35%;
  }

  & .nav-left {
    width: 50%;
    text-align: center;

    @media (max-width: 576px) {
      text-align: left;
      padding-left: 2em;
    }

    & button {
      border: none;
      border-radius: 50%;
      width: 2.5em;
      height: 2.5em;

      & svg {
        height: 100%;
      }
    }
  }

  & .nav-right {
    width: 50%;
    text-align: center;

    @media (max-width: 576px) {
      text-align: right;
      padding-right: 2em;
    }

    & button {
      border: none;
      border-radius: 50%;
      width: 2.5em;
      height: 2.5em;

      & svg {
        height: 100%;
      }
    }
  }
`;

const CarouselWide = (props) => {
  const [start, setStart] = useState(null);
  const [current, setCurrent] = useState(null);
  const [end, setEnd] = useState(null);

  useEffect(() => {
    if (props.data !== undefined) {
      if (start === null) {
        setStart(props.data.length - 1);
      }
      if (current === null) {
        setCurrent(0);
      }
      if (end === null) {
        setEnd(1);
      }
    }
  }, [start, current, end, props.data]);

  const changeNextValue = (payload) => {
    return payload > 0 ? payload - 1 : props.data.length - 1;
  };

  const changePreviousValue = (payload) => {
    return payload < props.data.length - 1 ? payload + 1 : 0;
  };

  const doNext = () => {
    setStart(changeNextValue(start));
    setCurrent(changeNextValue(current));
    setEnd(changeNextValue(end));
  };

  const doPrevious = () => {
    setStart(changePreviousValue(start));
    setCurrent(changePreviousValue(current));
    setEnd(changePreviousValue(end));
  };

  return (
    <Container>
      {start != null ? (
        <StartItem>
          <img src={props.data[start].image} alt="" />
          <div className="item-background"></div>
          <div className="item-content">
            <h3>{props.data[start].title}</h3>
            <p>{props.data[start].description}</p>
          </div>
        </StartItem>
      ) : (
        ""
      )}
      {current != null ? (
        <MainItem>
          <img src={props.data[current].image} alt="" />
          <div className="item-background"></div>
          <div className="item-content">
            <h3>{props.data[current].title}</h3>
            <p>{props.data[current].description}</p>
          </div>
        </MainItem>
      ) : (
        ""
      )}
      {end != null ? (
        <EndItem>
          <img src={props.data[end].image} alt="" />
          <div className="item-background"></div>
          <div className="item-content">
            <h3>{props.data[end].title}</h3>
            <p>{props.data[end].description}</p>
          </div>
        </EndItem>
      ) : (
        ""
      )}
      <Navigation>
        <div className="nav-left">
          <button onClick={doPrevious}>
            <ChevronLeft fill="#F2A900" />
          </button>
        </div>
        <div className="nav-right">
          <button onClick={doNext}>
            <ChevronRight fill="#F2A900" />
          </button>
        </div>
      </Navigation>
    </Container>
  );
};

export default CarouselWide;
